<template>
	<i class="" :class="classList"></i>
</template>
<script>
	export default {
		name: 'AsIcon',
		props: {
			name: String,
			isElement: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			classList() {
				if (this.isElement) {
					return [`el-icon-${this.name}`]
				} else {
					return ['s-iconfont', `shair-${this.name}`]
				}
			},
		}
	}
</script>
<style lang="scss">
 @import url('./iconfont/iconfont.css');
 .s-iconfont {
	font-size: inherit;
 }
</style>
